import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  disabled?: boolean;
  questionId?: number;
  questionsUrl: string;
  tooltip?: string;
  updateQuestions: () => Promise<void>;
}

const CalendarEventFeedbackQuestionRemove = ({
  disabled,
  questionId,
  questionsUrl,
  tooltip,
  updateQuestions
}: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    await api.delete(`${questionsUrl}${questionId ? `/${questionId}` : ''}`);
    await updateQuestions();
    return true;
  };

  const buttonProps = questionId
    ? {
        buttonText: messages.commonRemove,
        confirmText: messages.eventCalendarFeedbackQuestionRemoveMessage,
        confirmTitle: messages.eventCalendarFeedbackQuestionRemove,
        successMessage: messages.eventCalendarFeedbackQuestionRemoveSuccess
      }
    : {
        buttonText: messages.eventCalendarFeedbackQuestionRemoveAll,
        confirmText: messages.eventCalendarFeedbackQuestionRemoveAllMessage,
        confirmTitle: messages.eventCalendarFeedbackQuestionRemoveAll,
        successMessage: messages.eventCalendarFeedbackQuestionRemoveAllSuccess
      };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonTooltip={tooltip}
      category="danger"
      disabled={disabled}
      onConfirm={handleConfirm}
      {...buttonProps}
    />
  );
};

export default CalendarEventFeedbackQuestionRemove;
